import type { NavTabContext } from 'kci-design-lib';
import type { BackendTabContext, SaveTabPayload } from './tabManagementService';

export const TAB_CONTEXT_VERSION = 1;

export function toBackendTabContext(context: NavTabContext | undefined):
  Pick<SaveTabPayload, 'ContextVersion' | 'Context'> {
  if (!context) return {};

  let backendContext: BackendTabContext;
  switch (context.kind) {
    case 'chat':
      if (!context.sessionId) return {};
      backendContext = {
        Kind: 'chat',
        SessionId: context.sessionId,
        AgentId: context.agentId,
      };
      break;
    case 'workspace':
      backendContext = {
        Kind: 'workspace',
        WorkspaceId: context.workspaceId,
        ObjectiveId: context.objectiveId,
        ObjectiveType: context.objectiveType,
        ObjectiveCategory: context.objectiveCategory,
        PageId: context.pageId,
        ContentType: context.contentType,
        StorageKey: context.storageKey,
      };
      break;
    case 'agent':
      if (!context.agentId) return {};
      backendContext = {
        Kind: 'agent',
        AgentId: context.agentId,
        AgentName: context.agentName,
        IsGlobal: context.isGlobal,
        PageId: context.pageId,
      };
      break;
    case 'engagement':
      backendContext = {
        Kind: 'engagement',
        EngagementId: context.engagementId,
        ClientId: context.clientId,
        PageId: context.pageId,
      };
      break;
  }

  return { ContextVersion: TAB_CONTEXT_VERSION, Context: backendContext };
}